export default {"src":"/_next/static/media/open-icon.0445d295.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};